/**
* debouncer - Limits the rate at which a function can fire.
*
* Example:
*
* $(window).resize(debouncer(function(e) {
*   function();
* }, 300));
*
* @param {function} func The function you want to limit
* @param {ms} timeout Optional: timeout of the debouncer. Defaults at 200ms.
*/
const debouncer = (func, timeout = 300) => {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), timeout);
    };
};
